import React from "react";
import ImageCarousel from "./ImageCarousel";
import banner1 from "../../assets/images/promo/banner1.jpg";
import banner2 from "../../assets/images/promo/banner2.jpg";
import banner3 from "../../assets/images/promo/banner3.jpg";
import banner4 from "../../assets/images/promo/banner4.jpg";
import CustomBreadcrumb from "../../components/customBreadcrumb/CustomBreadcrumb";
import Title from "../../components/title/Title";

const Promo: React.FC = () => {
  const images = [
    {
      src: banner1,
      alt: "First banner",
      thumbnail: banner1,
    },
    {
      src: banner2,
      alt: "Second banner",
      thumbnail: banner2,
    },
    {
      src: banner3,
      alt: "Third banner",
      thumbnail: banner3,
    },
    {
      src: banner4,
      alt: "Forth banner",
      thumbnail: banner4,
    },
  ];

  return (
    <div className="page-container">
      <CustomBreadcrumb
        items={[
          { path: "/", title: "Home" },
          { path: "/serviceLineUp", title: "Service Line-up" },
          { path: "/promo", title: "Promo" },
        ]}
      />

      <Title>Promo</Title>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "24px 0",
          width: "100%",
        }}
      >
        <ImageCarousel images={images} autoPlay={true} interval={3000} />
      </div>
    </div>
  );
};

export default Promo;
